import React from "react";
import { createPortal } from "react-dom";

import {
  ChartData,
  OrgTimeSeriesMetricsData,
} from "../../../../models/ChartCollectionData";
import { DownloadCsvButton } from "../../../AnalysisCollectionsComponents/CollectionChartArea/Download";

import "./styles.scss";

export interface IFacilityDetailsAnalysisControlsProps {
  chartData: ChartData | null | undefined;
  chartDetails: OrgTimeSeriesMetricsData[];
  prevYearChartDetails: OrgTimeSeriesMetricsData[];
  compareToPrev: boolean;
  timeUnit?: "day" | "week" | "month";
}

export const FacilityDetailsAnalysisControls: React.FunctionComponent<
  IFacilityDetailsAnalysisControlsProps
> = (props) => {
  const {
    chartData,
    chartDetails,
    prevYearChartDetails,
    compareToPrev,
    timeUnit,
  } = props;

  if (!chartData) {
    return null;
  }

  // Hack to get around compare_to_prev not being set properly from the API
  // when in individual facility mode.
  const _chartData: ChartData = {
    ...chartData,
    compare_to_prev: compareToPrev,
  };

  // Portal is used to render these download buttons alongside the TimespanPicker component.
  // This is purely for presentation purposes and can be changed if needed to suit design.
  const portalElement = document.getElementById(`csv-download`);

  if (!portalElement) {
    return null;
  }

  // Extract start_date and end_date from chartDetails[0] if available
  const startDate = chartDetails?.[0]?.start_date;
  const endDate = chartDetails?.[0]?.end_date;

  return (
    <>
      {chartData &&
        createPortal(
          <div className="facility-details-analysis-controls-download">
            <DownloadCsvButton
              chartData={_chartData}
              chartDetailsDataForLines={chartDetails}
              prevYearChartDetailsDataForLines={prevYearChartDetails}
              forWindows={false}
              timeUnit={timeUnit}
              start_date={startDate}
              end_date={endDate}
            />
            <DownloadCsvButton
              chartData={_chartData}
              chartDetailsDataForLines={chartDetails}
              prevYearChartDetailsDataForLines={prevYearChartDetails}
              forWindows={true}
              timeUnit={timeUnit}
              start_date={startDate}
              end_date={endDate}
            />
          </div>,
          portalElement
        )}
    </>
  );
};
